import { Observable } from 'rxjs';
import { IBecaRequest } from 'src/app/models/beca/beca-request.model';

export abstract class SecondaryDataAbstractService {
  public abstract set lastFinalClassification(val: string);
  public abstract set isFallback(val: boolean);
  public abstract get isSaveDataAllowed(): boolean;
  public abstract secondaryData: IBecaRequest;
  public abstract saveSecondaryData(appFormId: string): Observable<any>;
}
